/* Geneva by Design — in-place filtering for the GV filter bar.
   Category pills and filter links swap the product grid without reloading the page,
   so the reading position is kept. Falls back to normal navigation on any error. */
(function () {
  if (window.__gvFacets) return;
  window.__gvFacets = true;

  var BAR = '.shopify-section--gv-fbar';
  var busy = false;

  function listSection() {
    var list = document.querySelector('product-list');
    return list ? list.closest('.shopify-section') : null;
  }

  function handled(a) {
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (e) { return false; }
    if (url.origin !== location.origin) return false;
    // Same collection / search page, only the query string differs.
    return url.pathname === location.pathname;
  }

  function swap(from, selector) {
    var next = from.querySelector(selector);
    var current = document.querySelector(selector);
    if (!next || !current) return false;
    current.replaceChildren.apply(current, Array.prototype.slice.call(document.importNode(next, true).childNodes));
    return true;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    var bar = event.target.closest ? event.target.closest(BAR) : null;
    if (!bar) return;
    var a = event.target.closest('a[href]');
    if (!a || !bar.contains(a) || !handled(a)) return;

    var section = listSection();
    if (!section || busy) return;

    event.preventDefault();
    busy = true;
    var url = new URL(a.href, location.href);
    var y = window.scrollY;
    bar.setAttribute('data-gv-busy', '');

    fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var listSelector = '#' + section.id;
        if (!swap(doc, listSelector)) throw new Error('no list');
        swap(doc, '#' + bar.id);
        history.replaceState({}, '', url.toString());
        window.scrollTo(0, y);
      })
      .catch(function () {
        window.location.href = url.toString();
      })
      .then(function () {
        busy = false;
        var current = document.querySelector(BAR);
        if (current) current.removeAttribute('data-gv-busy');
      });
  });

  /* The bar's own dropdown behaviour, delegated so it survives a swap. */
  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (!d || d.tagName !== 'DETAILS' || !d.closest(BAR) || !d.open) return;
    d.closest(BAR).querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  document.addEventListener('click', function (event) {
    document.querySelectorAll(BAR + ' details[open]').forEach(function (o) {
      if (!o.contains(event.target)) o.open = false;
    });
  });
})();
